import React from 'react';

import './index.scss';
import PreMealImage from './PreMealImage';
import { CountdownTimer, MealButton } from './molecules';

const MealReservationCard = ({ children, className }) => {
  return (
    <article className={`meal-card ${className || ''}`}>{children}</article>
  );
};

const HeaderCon = ({ children, className }) => (
  <div className={`meal-card__header ${className || ''}`}>{children}</div>
);

const Heading = ({ children, className }) => (
  <h2 className={`meal-card__title ${className || ''}`}>{children}</h2>
);

const Description = ({ children, className }) => (
  <p className={`meal-card__description ${className || ''}`}>{children}</p>
);

const EyeBrow = ({ children, className }) => (
  <span className={`meal-card__eyebrow ${className || ''}`}>{children}</span>
);

const Chip = ({ children, className }) => (
  <span className={`meal-card__chip ${className || ''}`}>{children}</span>
);

const Wrapper = ({ children, className }) => (
  <div className={`meal-card__wrapper ${className || ''}`}>{children}</div>
);

const Footer = ({ children, className }) => (
  <div className={`meal-card__footer ${className || ''}`}>{children}</div>
);

const Price = ({ children, className }) => (
  <h6 className={`meal-card__price ${className || ''}`}>{children}</h6>
);

MealReservationCard.HeaderCon = HeaderCon;
MealReservationCard.Heading = Heading;
MealReservationCard.Description = Description;
MealReservationCard.Button = MealButton;
MealReservationCard.EyeBrow = EyeBrow;
MealReservationCard.CountDownTimer = CountdownTimer;
MealReservationCard.Chip = Chip;
MealReservationCard.Image = PreMealImage;
MealReservationCard.Wrapper = Wrapper;
MealReservationCard.Footer = Footer;
MealReservationCard.Price = Price;

export default MealReservationCard;
